// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import { DeployTime } from './deploytime';
import { VERSION_INFO } from './version';
import "zone.js/plugins/zone-error";
export const environment = {
  production: false,
  extension: false,
  wp: false,
  HOST: process.env.FRONTEND_BASE_URL,
  SERVER_URL: process.env.SERVER_URL,
  deployDate: DeployTime.getInstance().getFormattedStartupDate(),
  version: DeployTime.getInstance().getVersion()
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
import "zone.js/plugins/zone-error"; // Included with Angular CLI.
